import { MutationTree } from 'vuex'

import { ChainStoreState } from '@/types/store'
import { ChainStoreEntity } from '../../../api/@types'

export const mutations: MutationTree<ChainStoreState> = {
  chainStoresLoaded(state, payload: ChainStoreEntity[]) {
    state.chainStores = payload
  },
}
